import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';

import { TabItemProps, TransferTabItem } from './TransferTabItem/TransferTabItem';

export type TransferTabsData = Array<Omit<TabItemProps, 'direction' | 'spacing'>>;

type Props = {
  tabs: TransferTabsData;
  direction?: TabItemProps['direction'];
  spacing?: TabItemProps['spacing'];
};

export const TransferTabs: React.FC<Props> = ({ tabs, direction = 'row', spacing = 1 }) => (
  <FlexLayout direction='row' className='sticky top-0 z-modal-popover'>
    {tabs.map((tabProps) => (
      <TransferTabItem key={tabProps.label} {...tabProps} direction={direction} spacing={spacing} />
    ))}
  </FlexLayout>
);
